import React, { useRef, useState } from 'react';
import { Upload } from '../../../../shared/assets/AppIcons';
import IconAction from '../../../../shared/components/IconAction';

// Decimal MB, leaving room for multipart metadata within the backend's 10 MiB request limit.
const MAX_FILE_BYTES = 10_000_000;
const fileKey = (file) => `${file.name}:${file.size}:${file.lastModified}`;

export default function AssignmentAttachmentPicker({ files, onChange, disabled = false }) {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [errors, setErrors] = useState([]);

  function addFiles(incoming) {
    if (disabled) return;
    const nextFiles = [...files];
    const seen = new Set(files.map(fileKey));
    const nextErrors = [];
    Array.from(incoming || []).forEach((file) => {
      if (file.size === 0) {
        nextErrors.push(`${file.name}: il file è vuoto.`);
      } else if (file.size > MAX_FILE_BYTES) {
        nextErrors.push(`${file.name}: supera il limite di 10 MB.`);
      } else if (!seen.has(fileKey(file))) {
        seen.add(fileKey(file));
        nextFiles.push(file);
      }
    });
    setErrors(nextErrors);
    onChange(nextFiles);
  }

  return <div className="party-form__field task-attachments">
    <label id="assignment-attachments-label" htmlFor="assignment-attachments-browse">File allegati</label>
    <input ref={inputRef} type="file" multiple hidden disabled={disabled} aria-label="Seleziona file allegati"
      onChange={(event) => {
        addFiles(event.target.files);
        event.target.value = '';
      }} />
    <button id="assignment-attachments-browse" type="button" disabled={disabled}
      className={`task-attachments__dropzone${dragging && !disabled ? ' is-dragging' : ''}`}
      aria-label="Allega file" aria-describedby="assignment-attachments-help"
      onClick={() => inputRef.current?.click()}
      onDragEnter={(event) => { event.preventDefault(); if (!disabled) setDragging(true); }}
      onDragOver={(event) => { event.preventDefault(); event.dataTransfer.dropEffect = disabled ? 'none' : 'copy'; }}
      onDragLeave={(event) => { if (!event.currentTarget.contains(event.relatedTarget)) setDragging(false); }}
      onDrop={(event) => { event.preventDefault(); setDragging(false); addFiles(event.dataTransfer.files); }}>
      <Upload size={30} aria-hidden="true" />
      <span>Trascina i file qui o <span className="task-attachments__browse">sfoglia</span></span>
      <small id="assignment-attachments-help">PDF, PNG, JPG, ZIP e altri formati · Max 10 MB per file</small>
    </button>
    {errors.length > 0 ? <div role="alert" className="task-form__error wt-inline-error">
      {errors.map((error, index) => <p key={index}>{error}</p>)}
    </div> : null}
    {files.length > 0 ? <>
      <p className="party-form__help" role="status">{files.length} {files.length === 1 ? 'file selezionato' : 'file selezionati'}</p>
      <ul className="task-attachments__files" aria-label="Allegati selezionati">
        {files.map((file, index) => <li key={fileKey(file)}>
          <span className="task-attachments__name">{file.name}<small>{new Intl.NumberFormat('it-IT', { maximumFractionDigits: 1 }).format(file.size / 1000)} KB</small></span>
          <IconAction iconKey="delete" tone="danger" label={`Rimuovi ${file.name}`} disabled={disabled}
            onClick={() => onChange(files.filter((_, fileIndex) => fileIndex !== index))} />
        </li>)}
      </ul>
    </> : null}
  </div>;
}
